'use strict';
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils = __importStar(require("../utils"));
var CodecOutputLength = 29;
var IsTest = function (destination) {
    if (typeof destination === 'string' && destination.match(/^T/)) {
        return true;
    }
    if (typeof destination === 'object' && destination.test === true) {
        return true;
    }
    return false;
};
exports.IsTest = IsTest;
var CodecOptions = function (destination) {
    var char = IsTest(destination)
        ? 'T'
        : 'X';
    return {
        version: utils.findPrefix(char, CodecOutputLength),
        expectedLength: CodecOutputLength
    };
};
exports.CodecOptions = CodecOptions;
